import React, { useState, useEffect } from "react";
import style from "./Banner.module.css";

import banner1 from "../assets/banners/banner1.webp";
import banner2 from "../assets/banners/banner2.webp";
import banner3 from "../assets/banners/banner3.webp";
import banner4 from "../assets/banners/banner4.webp";
import banner5 from "../assets/banners/banner5.webp";

function Banner() {
    const images = [banner1, banner2, banner3, banner4, banner5];
    const textData = [
        { title: "Bienvenidos a Dentisan", subtitle: "Aquí comienza tu mejor sonrisa." },
        { title: "Protección de por Vida", subtitle: "Cuida tus dientes, son para toda la vida." },
        { title: "Cuidado con Corazón", subtitle: "Cuidamos tu sonrisa como si fuera la nuestra." },
        { title: "Salud Integral", subtitle: "La salud bucal es parte de tu bienestar general." },
        { title: "Sonrisas que Inspiran", subtitle: "Dientes felices, paciente feliz." },
    ];

    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [isPaused, setIsPaused] = useState(false);

    useEffect(() => {
        if (isPaused) return;
        const intervalId = setInterval(() => {
            setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 4000);
        return () => clearInterval(intervalId);
    }, [isPaused, images.length]);

    return (
        <div
            className={style.bannerContainer}
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}
        >
            {images.map((img, index) => (
                <div
                    key={index}
                    className={`${style.bannerSlide} ${index === currentImageIndex ? style.active : ""}`}
                    role="img"
                    aria-label={`${textData[index].title} - ${textData[index].subtitle}`}
                    style={{
                        backgroundImage: `linear-gradient(to right, rgba(0, 0, 0, 0.48), rgba(0, 0, 0, 0.03) 100%), url(${img})`,
                    }}
                >
                    <div className={style.textContainer}>
                        <h2 className={style.bannerTitle}>{textData[index].title}</h2>
                        <p className={style.bannerSubtitle}>{textData[index].subtitle}</p>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default Banner;
